import BaseModelAPI from '../BaseModelAPI';

export default class PurchaseOrder extends BaseModelAPI {
	static entity = 'purchaseorder';
	static entityName = 'purchaseorder';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.purchaseOrderNumber = '';
		this.purchaseRequestId = '';
		this.purchaseRequest = {};
		this.purchaseOrderDate = '';
		this.deliveryDateRequest = '';
		this.purpose = '';
		this.remark = '';
		this.totalQty = 0;
		this.totalAmount = 0;
		this.poStatus = {};
		this.totalPricePpn = 0;
		this.revisi = 0;
		this.vendorId = '';
		this.vendor = {};
		this.contactPerson = '';
		this.quotationNumber = '';
		this.quotationDate = '';
		this.purchaseOrderDetail = []
		this.ppn = 0;
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		this.isManualNumber = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async generatePurchaseOrderDetails(this_, id, prefix) {
		return this_.$http.put(`${this.entityName}/generatepurchaseorderdetails/${id}?prefix=${prefix}`)
			.then(response => {
				return response.data;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async recalculateSummary(this_, id) {
		return this_.$http.put(`${this.entityName}/recalculateSummary/${id}`)
			.then(response => {
				return response.data;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async PrintPoPdf(this_, id) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";
		//let ids = _this.$store.state.dataIds;
		return this_.$http.get(`${this.entityName}/printpopdf/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}
}